import { Node, Path } from "slate";

export default function getParentNode(editor) {
  const { selection } = editor;

  if (!selection) {
    return null;
  }

  const parentPath = Path.parent(selection.anchor.path);
  const parentNode = Node.get(editor, parentPath);
  return parentNode;
}
